import { routerNavigatedAction } from '@ngrx/router-store';
import { on } from '@ngrx/store';

import { JobToolState, jobToolInitialState } from '../../job-tool.reducer';

import { DiscardOpportunityDialogActions } from '../discard-job-component/discard-job.actions';

export const jobCreateReducers = [
    on(DiscardOpportunityDialogActions.discardUnsavedChangesButtonClicked, (): JobToolState => jobToolInitialState),
    on(routerNavigatedAction, (state: JobToolState, { payload: { event: { urlAfterRedirects } } }): JobToolState => {
      if (urlAfterRedirects.startsWith('/jobs/new')) {
        return jobToolInitialState;
      }
      return state;
    }),
] as const;
